import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import { addShopAccount } from '../../actions/Accounts';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { addShopImage, editShop } from '../../actions/Shop';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 10,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  mainPaper: {
    boxShadow: 'none',
    marginTop: 10,
    marginBottom: 10
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: 10,
    fontSize: 12,
    wordBreak: 'break-all'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  marginBottom12: {
    marginBottom: '12px'
  },
  marginBottom5: {
    marginBottom: '5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { addShopAccount, addShopImage, editShop },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openShopAddProgress', 'updateOpenShopAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isShopAddSuccess', 'updateIsShopAddSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('prefecture', 'setPrefecture', 0),
  withState('shopCategory', 'setShopCategory', 0),
  withState('phone', 'setPhone', ''),
  withState('phoneAuthCode', 'setPhoneAuthCode', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    openShopAddProgress,
    updateOpenShopAddProgress,
    loading,
    updateLoading,
    isShopAddSuccess,
    updateIsShopAddSuccess,
    resultMessage,
    setResultMessage,
    handleRedirect,
    backAction,
    addConfirm,
    addParam,
    shopId,
    prefectures,
    shopCategories,
    updateOpenShopAdd,
    updateOpenShopAddConfirm,
    enableShopBank,
    reGetAccounts
  }) => {
    console.log(enableShopBank, addConfirm, addParam);
    const registerAction = async () => {
      updateLoading(true);
      updateOpenShopAddProgress(true);
      const addedShop = await actions
        .editShop(shopId, addParam)
        .then(data => checkSession(data));

      // const addedShop = await actions
      //   .addShopAccount(addParam)
      //   .then(data => checkSession(data));
      const imagePaths = await Promise.all(
        Object.keys(addParam.images).map(async i => {
          if (addParam.images[i].image !== null) {
            let { image } = addParam.images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile('shop', shopId, image, 'public');
            return imagePath;
          }
          if (addParam.images[i].imagePath !== null) {
            return addParam.images[i].imagePath;
          }
          return null;
        })
      );
      const images = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      if (Object.keys(images).length !== 0) {
        await actions
          .addShopImage(shopId, {
            images
          })
          .then(data => checkSession(data));
      }
      if (addedShop.type === 'EDIT_SHOP_SUCCESS') {
        updateIsShopAddSuccess(true);
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsShopAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isShopAddSuccess) {
        updateOpenShopAdd(false);
        updateOpenShopAddConfirm(false);
        updateOpenShopAddProgress(false);
        if (reGetAccounts && typeof reGetAccounts === 'function') {
          reGetAccounts();
        }
        handleRedirect('/release_step');
      } else {
        updateOpenShopAddProgress(false);
      }
    };

    return (
      <div className={classes.root}>
        <Typography variant="h6">店舗情報確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗名</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.shopName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗名かな
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.shopNameKana}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className={classes.tableCellItem}>郵便番号</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.zipCode}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>都道府県</TableCell>
              <TableCell className={classes.tableCellData}>
                {prefectures.map(item => {
                  if (
                    addConfirm.prefectureCode.toString() === item.id.toString()
                  ) {
                    return item.name;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>市区町村</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.city}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>町名</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.address1}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>番地</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.address2}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>建物名</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.building}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗カテゴリー
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {shopCategories.map(item => {
                  if (
                    addConfirm.shopCategoryId &&
                    addConfirm.shopCategoryId.toString() === item.id.toString()
                  ) {
                    return item.name;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                運営会社名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.shopGroupName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ご担当者名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.shopContactName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>所属部署</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.department}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                電話番号（担当者）
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.contactPhone}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗電話番号
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.phone}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                メールアドレス
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addParam.email}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗概要</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.introduction}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>営業時間</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.businessHours}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>定休日</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.holiday}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>価格帯</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.priceRange}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>最寄駅</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.nearestStation}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>アクセス</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.access}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                WebページURL
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.webPage}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.tagStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>画像</TableCell>
              <TableCell className={classes.tableCellData}>
                <ImagePreview previewImage={addConfirm.previewImage1} />
                <ImagePreview previewImage={addConfirm.previewImage2} />
                <ImagePreview previewImage={addConfirm.previewImage3} />
                <ImagePreview previewImage={addConfirm.previewImage4} />
                <ImagePreview previewImage={addConfirm.previewImage5} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>SNS</TableCell>
              <TableCell className={classes.tableCellData}>
                <div className={classes.margin}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    className={classes.marginBottom12}
                  >
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Facebook"
                        height="24"
                        image="/images/icon_facebook.png"
                        title="Facebook"
                        className={classes.marginBottom5}
                      />
                    </Grid>
                    <Grid item xs={12} sm container className={classes.textSNS}>
                      {addConfirm.snsFacebook}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    className={classes.marginBottom12}
                  >
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Twitter"
                        height="24"
                        image="/images/icon_twitter.png"
                        title="Twitter"
                        className={classes.marginBottom5}
                      />
                    </Grid>
                    <Grid item xs={12} sm container className={classes.textSNS}>
                      {addConfirm.snsTwitter}
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Instagram"
                        height="24"
                        image="/images/icon_instagram.png"
                        title="Instagram"
                        className={classes.marginBottom5}
                      />
                    </Grid>
                    <Grid item xs={12} sm container className={classes.textSNS}>
                      {addConfirm.snsInstagram}
                    </Grid>
                  </Grid>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>座席</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.numberSit}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>禁煙/喫煙</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.smoking}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>駐車場</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.parking}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗詳細表示制限
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.stealthModeStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                誰でもごち制限
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.gochiRestrictionStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                社食ごちめし現金授受の有無
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.cashAllowed ? '利用する' : '利用しない'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                社食ごちめし金額指定チケット利用の有無
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.allowMenuPriceShashoku
                  ? '受け付ける'
                  : '受け付けない'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ごちめしの紹介者
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.preGochiUserStr}
              </TableCell>
            </TableRow>
            {enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  入金管理
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.depositManageStr}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && addParam.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>銀行名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.bankName}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && addParam.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>支店名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.bankBranchName}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && addParam.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座種別
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.bankAccountTypeStr}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && addParam.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座番号
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.bankAccountNumber}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && addParam.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座名義
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.bankAccountHolder}
                </TableCell>
              </TableRow>
            )}
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
        <ProgressDialog
          openProgress={openShopAddProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
